module.exports = __webpack_public_path__ + "assets/img/relate_line_help.3f87e4b8.png";